
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { AnalystReactionViewPage } from '@/components/Pages/AnalystReactions/AnalystReactionViewPage';
import { ForbiddenPage } from '@/components/Pages/Errors/ForbiddenPage';
import { getAnalyticsData, getBaseAnalytics } from '@/components/Templates/InfiniteScrollPage/InfiniteScrollPage';
import { BaseAppContextContainer } from '@/contexts/AppContext/AppContextContainer';
import { getAppContextServerSideProps } from '@/contexts/AppContext/AppContextServer';
import { ContentType } from '@/interfaces';
import { getPublicMetadataForTerminalContent } from '@/services/TerminalContent';
import type { ComponentProps } from 'react';
const getServerSideProps = getAppContextServerSideProps(async ({ query, api, res }) => {
    const apiQuery: any = {};
    const storyLanguage = query?.language?.toString();
    if (storyLanguage) {
        apiQuery.translationLanguageTarget = storyLanguage.toLowerCase();
    }
    try {
        const data = await api.get({
            path: '/analyst_reactions/[ID]',
            replacements: { id: query.id?.toString() },
            query: apiQuery,
        });
        if (data?.canonicalResource) {
            let url = data.canonicalResource.url;
            if (storyLanguage) {
                url += `?language=${storyLanguage}`;
            }
            return { redirect: { destination: url, statusCode: 301 } };
        }
        if (data?.analystReaction) {
            api.post({
                path: '/users/content_view',
                body: { contentId: data.analystReaction.id, contentType: ContentType.analystreaction },
            }).catch(() => { });
            return {
                props: {
                    ...data,
                    analyticsMetadata: getAnalyticsData(ContentType.analystreaction, data.analystReaction.id),
                },
            };
        }
        return { notFound: true };
    }
    catch (e) {
        const acceptableHttpErrors = [403];
        if (e.hasOwnProperty('response') && acceptableHttpErrors.includes(e?.response?.status)) {
            res.statusCode = e.response.status;
            return {
                props: {
                    analyticsMetadata: getBaseAnalytics(ContentType.analystreaction),
                    responseCode: e.response.status,
                },
            };
        }
        throw e;
    }
}, getPublicMetadataForTerminalContent);
export default class extends BaseAppContextContainer<ComponentProps<typeof AnalystReactionViewPage> & {
    responseCode?: number;
}> {
    public render() {
        if (this.props?.responseCode === 403) {
            return <ForbiddenPage />;
        }
        return (<AnalystReactionViewPage analystReaction={this.props.analystReaction} relatedStories={this.props.relatedStories} translationLocales={this.props.translationLocales}/>);
    }
}

    async function __Next_Translate__getServerSideProps__1a15f1cd540__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/analyst-reactions/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a15f1cd540__ as getServerSideProps }
  